import React, {
    useState,
    useEffect,
    useContext
} from 'react';

import { Link } from 'react-router-dom';
import './header.css';
import { SideNavContext } from '../../contexts';
import Image from '../Image';

const Header = () => {

    const [isHeaderActive, setIsHeaderActive] = useState(false);
    const { toggleSideNav } = useContext(SideNavContext);

    useEffect(() => {
        const handleScroll = () => {
            setIsHeaderActive(window.scrollY > 0);
        };

        handleScroll();

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const _toggleSideNav = () => {
        toggleSideNav.open();
    };

    return (
        <header
            className={
                isHeaderActive
                    ? 'mt-header active'
                    : 'mt-header'
            }
        >
            <div className="mt-header-inner">
                {/* LOGO */}
                <div className="mt-header-logo">
                    <Link to="/">
                        <Image
                            url={
                                isHeaderActive
                                    ? '/images/logo4.png'
                                    : '/images/logo5.png'
                            }
                            logo
                        />
                    </Link>
                </div>

                {/* PC MENU */}
                <nav className="mt-header-nav">
                    <ul>
                        <li>
                            <Link to="/business">
                                사업분야
                            </Link>
                        </li>
                        <li>
                            <Link to="/portfolio">
                                시공사례
                            </Link>
                        </li>
                        <li className="header-nav-item header-product-menu">
                            <span className="header-nav-link">
                                제품소개
                            </span>

                            <div className="header-product-dropdown">
                                <Link to="/products/led">
                                    <span>LED DISPLAY</span>
                                    LED 전광판
                                </Link>

                                <Link to="/products/projector">
                                    <span>PROJECTOR</span>
                                    빔프로젝터
                                </Link>
                            </div>
                        </li>
                        <li>
                            <Link to="/rentalService">
                                가이드
                            </Link>
                        </li>
                        <li>
                            <Link to="/support">
                                고객지원
                            </Link>
                        </li>
                    </ul>
                </nav>

                {/* PC RIGHT */}
                <div className="mt-header-right">
                    <a
                        href="tel:01090453707"
                        className="mt-header-phone"
                    >
                        <span>☎</span>
                        <span>
                            010-9045-3707
                        </span>
                    </a>
                    <Link
                        to="/inquiry"
                        className="mt-header-inquiry"
                    >
                        견적문의
                    </Link>

                </div>

                {/* MOBILE */}
                <div className="mt-header-mobile">
                    <button
                        type="button"
                        className="mt-header-mobile-button"
                        onClick={_toggleSideNav}
                        aria-label="메뉴 열기"
                    >
                        <i className="mdi mdi-menu"></i>
                    </button>
                </div>
            </div>
        </header>
    );
};


export default Header;